import styled from "styled-components";

export const MainContainer = styled.main`
  display: block;
  width: 100%;
  height: 100%;
  font-size: var(--size-body);
  * {
    font-size: var(--size-body);
  }
`;
